var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLeftArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 19",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.615 18.578c.281.274.615.422 1.011.422a1.463 1.463 0 001.001-2.53l-7.09-6.98 7.09-6.96c.292-.295.459-.674.459-1.064C11.086.654 10.429 0 9.626 0c-.406 0-.74.137-1.011.411L.618 8.32C.263 8.667.086 9.047.086 9.5c0 .443.167.822.532 1.18l7.997 7.898z"
  })));
}

export default SvgLeftArrow;